export enum LoginCardTypeEnum {
    LOGIN = 'LOGIN',
    RECOVERY = 'RECOVERY',
    EMAIL_SENT = 'EMAIL_SENT',
    CHANGE_PASSWORD = 'CHANGE_PASSWORD'
}

export enum ChangePasswordTypeEnum {
    RECOVERY = 'RECOVERY',
    CHANGE_PASSWORD_AFTER_FIRST_LOGIN = 'CHANGE_PASSWORD_AFTER_FIRST_LOGIN'
}

export interface LoginLayoutState {
    loadingTranslations: boolean
    card: LoginCardTypeEnum
}
export const initialLoginLayoutState =
    (): LoginLayoutState => ({
        loadingTranslations: true,
        card: LoginCardTypeEnum.LOGIN
    })
